import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Select2Option, Select2UpdateEvent } from "ng-select2-component";
import { Subject } from 'rxjs';
import { AttachmentTypes, CrTypes } from 'src/app/franchise-app-global';
import { Extension } from 'src/app/franchise-update/models/models';
import { TradeMarkService } from 'src/app/services/TradeMarkService';
import { AttachmentContent, FileUploadComponent, FileUploaderAction } from 'src/app/shared/components/file-upload/file-upload.component';
import { GetTradeMarkByCRNumberModel, GetTradeMarkInfoByTMIdModel } from 'src/app/shared/models/models';


export interface TrademarkViewModel {
  id?: string | null;
  arabicName?: string | null;
  englishName?: string | null;
  logoPublicId?: string | null;
  isSelectedTrademark?: boolean;
}

@Component({
  selector: 'app-trademark-info',
  templateUrl: './trademark-info.component.html',
  styleUrls: ['./trademark-info.component.scss']
})
export class TrademarkInfoComponent implements OnInit, AfterViewInit {
  private _error = new Subject<string>();
  submitted: boolean = false;

  @ViewChild("tradeMarkLogofileUpload") tradeMarkLogofileUpload: FileUploadComponent;

  @Input() requestId: number = 0;
  @Input() requestTypeId: number = 0;
  @Input() crType: CrTypes;
  @Input() crNumber: string = '';
  @Input() editMode: boolean = false;
  @Input() trademarkModel: TrademarkViewModel | null;
  @Output() model = new EventEmitter<TrademarkViewModel | null>();

  formGroup: FormGroup;
  tradeMarkArabicNameRequired: boolean = true; tradeMarkArabicNameLenghtValid: boolean = true; tradeMarkArabicNamePattern: boolean = true;
  tradeMarkEnglishNameRequired: boolean = true; tradeMarkEnglishNameLenghtValid: boolean = true; tradeMarkEnglishNamePattern: boolean = true;
  tradeMarkLogoRequired: boolean = true;


  extensions: Array<Extension> = [{ Id: 1, Name: 'jpg', Size: '5MB' }, { Id: 2, Name: 'jpeg', Size: '5MB' }]
  objectId = 0;
  objectTypeId = 0;
  tradeMarkLogoAttachmentTypeId = AttachmentTypes.Trademark;

  isCRExternal: boolean = false;
  trademarks: Array<Select2Option> | null;
  isSelectedTradeMarkId: boolean = false;
  tradeMarkArabicNameHasValue: boolean = false;
  tradeMarkEnglishNameHasValue: boolean = false;
  tradeMarkLogoHasValue: boolean = false;

  constructor(private fb: FormBuilder, private translate: TranslateService, private trademarkService: TradeMarkService) { }

  ngOnInit() {
    this.objectId = this.requestId;
    this.objectTypeId = this.requestTypeId;
    this.isCRExternal = this.crType === CrTypes.External;

    this.loadModel();
    this.loadForm();
    this.getTrademarks();
  }
  ngAfterViewInit() {
    if (this.trademarkModel?.logoPublicId && !this.form_Group.controls['tradeMarkLogo'].value) {
      this.previewUploadedFile(this.trademarkModel.logoPublicId);
    }
    else if (!this.editMode && this.tradeMarkLogofileUpload) {
      this.tradeMarkLogofileUpload.deleteFile(this.trademarkModel?.logoPublicId);
    }
    // console.log(this.tradeMarkLogofileUpload.files);
  }

  resetView() {
    if (this.trademarkModel) {
      if (this.trademarkModel.logoPublicId && !this.form_Group.controls['tradeMarkLogo'].value) {
        this.previewUploadedFile(this.trademarkModel.logoPublicId);
      }

      if (this.editMode && this.tradeMarkLogofileUpload) {
        this.tradeMarkLogofileUpload.deleteFile(this.trademarkModel.logoPublicId);
      }

      this.isSelectedTradeMarkId = false;
      this.trademarkModel = null;

      this.loadModel();
      this.loadForm();
      this.getTrademarks();
    }
  }
  get form_Group() {
    return this.formGroup;
  }
  validateForm() {
    this.prepareModel();
  }

  fileUploadSuccess(message: any) {
    if (this.trademarkModel) {
      this.trademarkModel.logoPublicId = '';
      this.formGroup.controls['tradeMarkLogo'].setValue('');
    }

    if (message && message.action === FileUploaderAction.Upload && message.publicId) {
      this.previewUploadedFile(message.publicId);
    }
  }
  fileUploadError(message: any) {
    if (this.trademarkModel) {
      this.trademarkModel.logoPublicId = '';
      this.formGroup.controls['tradeMarkLogo'].setValue('');
    }
  }
  attachmentFiles(files: any) {
    if (this.trademarkModel) {
      this.trademarkModel.logoPublicId = '';
      this.formGroup.controls['tradeMarkLogo'].setValue('');
    }

    const file = files && files.length > 0 ? files[0] : null;
    if (file && file.publicId) {
      this.previewUploadedFile(file.publicId);
    }

  }

  getTrademarkInfo(event: Select2UpdateEvent<any>, isNewTrademark: boolean = true) {
    if (event == null || event.value.toString() === "") {
      if (this.trademarkModel) {
        this.trademarkModel.id = '';
        this.trademarkModel.arabicName = '';
        this.trademarkModel.englishName = '';
        this.trademarkModel.logoPublicId = '';
        this.trademarkModel.isSelectedTrademark = false;
        this.isSelectedTradeMarkId = false;
      }

      this.loadForm();
      return;
    }

    this.isSelectedTradeMarkId = false;

    if (isNewTrademark && this.tradeMarkLogofileUpload) {
      this.tradeMarkLogofileUpload.deleteFile(this.trademarkModel?.logoPublicId);
    }

    this.trademarkService.GetTradeMarkInfoByTMId(event.value.toString()).subscribe((response: GetTradeMarkInfoByTMIdModel) => {
      if (response) {
        this.isSelectedTradeMarkId = true;
        this.tradeMarkArabicNameHasValue = response.arabicName ? true : false;
        this.tradeMarkEnglishNameHasValue = response.englishName ? true : false;
        this.tradeMarkLogoHasValue = response.tradeMarkImage ? true : false;

        if (isNewTrademark) {
          this.formGroup.controls['tradeMarkId'].setValue(response.tradeMarkId);
          this.formGroup.controls['tradeMarkArabicName'].setValue(response.arabicName ? response.arabicName : '');
          this.formGroup.controls['tradeMarkEnglishName'].setValue(response.englishName ? response.englishName : '');
          this.formGroup.controls['tradeMarkLogo'].setValue(response.tradeMarkImage ? `data:image/png;base64,${response.tradeMarkImage}` : '');
        }
        else {
          this.formGroup.controls['tradeMarkId'].setValue(response.tradeMarkId);
          this.formGroup.controls['tradeMarkArabicName'].setValue(response.arabicName ? response.arabicName : this.trademarkModel?.arabicName);
          this.formGroup.controls['tradeMarkEnglishName'].setValue(response.englishName ? response.englishName : this.trademarkModel?.englishName);
          this.formGroup.controls['tradeMarkLogo'].setValue(response.tradeMarkImage ? `data:image/png;base64,${response.tradeMarkImage}` : '');
        }
      }
    },
      error => {
        if (error.status == "403")
          this._error.next(error.error.error.message);
        else
          this.translate.get("ErrorCodes.RetrieveError").subscribe(msg => this._error.next(msg));

        window.scrollTo(0, 0);
      });
  }

  private getTrademarks() {
    if (!this.isCRExternal && this.crNumber) {
      this.trademarkService.GetTradeMarkByCRNumber(this.crNumber).subscribe((response: GetTradeMarkByCRNumberModel[]) => {
        // this.trademarkService.GetTradeMarkByCRNumber('4030341741').subscribe((response: GetTradeMarkByCRNumberModel[]) => {
        this.trademarks = [];
        let defaultText = "";
        this.translate.get("Trademark_info.TradeMarkDefaultText").subscribe(msg => defaultText = msg);
        this.trademarks.push({ value: "", label: defaultText });
        if (response) {
          response.filter(x => x.localizedString).forEach(element => {
            this.trademarks?.push({ value: element.tradeMarkId, label: element.localizedString });
          });

          if (this.trademarkModel?.id) {
            this.getTrademarkInfo({ value: this.trademarkModel.id } as Select2UpdateEvent<any>, false);
          }
        }
      }, error => {
        this.trademarks = null;
        if (error.status == "403")
          this._error.next(error.error.error.message);
        else
          this.translate.get("ErrorCodes.RetrieveError").subscribe(msg => this._error.next(msg));
        window.scrollTo(0, 0);
      });
    }
  }
  private previewUploadedFile(publicId: string) {
    if (this.trademarkModel) {
      this.trademarkModel.logoPublicId = publicId;
    }

    this.tradeMarkLogofileUpload.preview(publicId).subscribe(
      (res: AttachmentContent) => {
        if (res && res.content) {
          this.formGroup.controls['tradeMarkLogo'].setValue(`data:image/png;base64,${res.content}`);
        }
      },
      error => { }
    );
  }

  private loadForm() {
    this.formGroup = this.fb.group({
      tradeMarkId: [this.trademarkModel?.id],
      tradeMarkArabicName: [this.trademarkModel?.arabicName, [Validators.required, Validators.minLength(1), Validators.maxLength(200), Validators.pattern(/^[\u0621-\u064A 0-9]+$/)]],
      tradeMarkEnglishName: [this.trademarkModel?.englishName, [Validators.required, Validators.minLength(1), Validators.maxLength(200), Validators.pattern(/^[a-zA-Z 0-9]+$/)]],
      tradeMarkLogo: ['', [Validators.required]],
    });

    if (!this.editMode && this.tradeMarkLogofileUpload) {
      this.tradeMarkLogofileUpload.deleteFile(this.trademarkModel?.logoPublicId);
    }

    this.tradeMarkArabicNameHasValue = false;
    this.tradeMarkEnglishNameHasValue = false;
    this.tradeMarkLogoHasValue = false;

  }
  private loadModel() {
    if (!this.trademarkModel) {
      this.trademarkModel = {
        id: '',
        arabicName: '',
        englishName: '',
        logoPublicId: '',
        logoContent: '',
        isSelectedTrademark: false
      } as TrademarkViewModel;
    }
    else {
      if (this.trademarkModel.id) {
        this.isSelectedTradeMarkId = true;
      }
    }
  }
  private prepareModel() {
    this.submitted = true;
    let trademarkObj = null;
    if (this.form_Group.valid) {
      const formControls = this.form_Group.controls;
      if (this.isSelectedTradeMarkId) {
        trademarkObj = {
          id: formControls['tradeMarkId'].value,
          arabicName: formControls['tradeMarkArabicName'].value,
          englishName: formControls['tradeMarkEnglishName'].value,
          logoPublicId: this.trademarkModel?.logoPublicId,
          isSelectedTrademark: this.isSelectedTradeMarkId
        } as TrademarkViewModel
      }
      else {
        trademarkObj = {
          id: null,
          arabicName: formControls['tradeMarkArabicName'].value,
          englishName: formControls['tradeMarkEnglishName'].value,
          logoPublicId: this.trademarkModel?.logoPublicId,
          isSelectedTrademark: this.isSelectedTradeMarkId
        } as TrademarkViewModel
      }
    }

    this.model.emit(trademarkObj);
  }
}
